import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Container,
  Paper,
} from "@mui/material";
import PaymentForm from "./PaymentForm";
import PaymentStatus from "./PaymentStatus";
import { getHeader, toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
export const ZOHO_ACCOUNT_ID = "60043549454";
export const ZOHO_API_KEY =
  "1003.718e1a6cd329905d410938ef2ed3ee4d.dd3bc9f57a781f5f67c2bb6518d7b30a";
const PaymentWidget = () => {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [widgetLoaded, setWidgetLoaded] = useState(false);

  const handlePayment = useCallback(async (paymentData) => {
    let instance = new window.ZPayments({
      account_id: ZOHO_ACCOUNT_ID,
      domain: "IN",
      otherOptions: {
        api_key: ZOHO_API_KEY,
      },
    });
    try {
      const paymentSession = await axios.post(
        `${API_ENDPOINT}/payment/create-zoho-payment-session?accountId=${ZOHO_ACCOUNT_ID}`,
        paymentData,
        getHeader()
      );
      setLoading(true);
      setPaymentStatus(null);
      let options = {
        amount: paymentData.amount,
        currency_code: "INR",
        payments_session_id: paymentSession.data.data.payments_session_id,
        currency_symbol: "₹",
        business: "Zylker",
        description: "Purchase of Zylker electronics.",
        invoice_number: "INV-12345",
        reference_number: "REF-12345",
        address: {
          name: "Canon",
          email: "canonbolt@zylker.com",
          phone: "98XXXXXXXX",
        },
      };
      let data = await instance.requestPaymentMethod(options);
    } catch (error) {
      if (error.code != "widget_closed") {
        toastError(error);
      }
    } finally {
      await instance.close();
    }
  }, []);

  const verifyPayment = async (paymentId) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/verify-payment`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ payment_id: paymentId }),
      }
    );
    if (!response.ok) throw new Error("Payment verification failed");
    return response.json();
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h5" gutterBottom align="center">
          Make a Payment
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" my={4}>
            <CircularProgress />
          </Box>
        ) : paymentStatus ? (
          <PaymentStatus status={paymentStatus} />
        ) : (
          <PaymentForm onSubmit={handlePayment} widgetReady={widgetLoaded} />
        )}
      </Paper>
    </Container>
  );
};

export default PaymentWidget;
